export default "/images/vendor/jquery-ui/themes/base/ui-icons_555555_256x240.png?d184ebcfe5b609497d9df1e36d321619";